import { Typography } from "antd";
import React from "react";
import { PriceTier } from "../interface";
import { formatAmount, formatWeeks } from "../pricing";

const { Text } = Typography;

interface Props {
  tiers: PriceTier[];
}

const cellStyle: React.CSSProperties = {
  padding: "8px 12px",
  borderBottom: "1px dashed var(--neutral-alter)",
  textAlign: "left",
  whiteSpace: "nowrap",
};

const amountStyle: React.CSSProperties = {
  ...cellStyle,
  textAlign: "right",
  fontVariantNumeric: "tabular-nums",
};

/**
 * Price overview generated from a booking season's price tiers.
 */
const PriceTable: React.FC<Props> = ({ tiers }) => (
  <div
    style={{
      border: "1px dashed var(--neutral-alter)",
      backgroundColor: "var(--neutral-alt)",
      borderRadius: "6px",
      overflowX: "auto",
      maxWidth: "670px",
      margin: "8px 0",
    }}
  >
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={cellStyle}>
            <Text type="secondary">Pristrinn</Text>
          </th>
          <th style={cellStyle}>
            <Text type="secondary">Uker</Text>
          </th>
          <th style={amountStyle}>
            <Text type="secondary">Pris</Text>
          </th>
          <th style={amountStyle}>
            <Text type="secondary">Torsdagstillegg</Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {tiers.map((tier, i) => {
          const last = i === tiers.length - 1;
          const rowCell = last ? { ...cellStyle, borderBottom: "none" } : cellStyle;
          const rowAmount = last ? { ...amountStyle, borderBottom: "none" } : amountStyle;
          return (
            <tr key={tier.name}>
              <td style={rowCell}>
                <Text strong>{tier.name}</Text>
              </td>
              <td style={rowCell}>
                <Text>{formatWeeks(tier.weeks)}</Text>
              </td>
              <td style={rowAmount}>
                <Text>{formatAmount(tier.price)}</Text>
              </td>
              <td style={rowAmount}>
                <Text>{tier.thursday_surcharge > 0 ? `+ ${formatAmount(tier.thursday_surcharge)}` : "–"}</Text>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default PriceTable;
